<template>
  <section
    class="content"
    id="mastheadCarousel"
    v-if="(promotions && promotions.length > 0)"
  >
    <section>
      <div class="home-slider">
        <div
          id="carouselExampleControls"
          class="carousel slide"
          data-ride="carousel"
        >
          <div
            class="carousel-inner"
            v-for="(promotion, index) in promotions"
            v-bind:key="promotion.url"
          >
            <div
              class="carousel-item"
              :class="activeIndex === index ? 'active' : ''"
            >
              <!--Click On Promotion Disabled-->
              <!--<img-->
                <!--class="d-block"-->
                <!--style="cursor: default"-->
                <!--v-lazy="promotion.image_url"-->
                <!--alt="Second slide"-->
                <!--@click.prevent="redirectionToWpi()"-->
                <!--:id="'masthead-carousel-'+index"-->
																<!--:data-test="'mastHeadCarouselPromoImg'+index"-->
              <!--&gt;-->
													<!--class w-100 removed grom img-->
              <img class="d-block"
              style="cursor: pointer"
              v-lazy="promotion.image_url"
              alt="Second slide"
              @click.prevent="promotionFunction(promotion)"
              :id="'masthead-carousel-'+index"
														:data-test="'mastHeadCarouselPromoImg'+index"
              >
            </div>
            <!--<div class="carousel-item">-->
            <!--<img class="d-block w-100" src="@/assets/img/gift.jpg"
              alt="Second slide">-->
            <!--</div>-->
            <!--<div class="carousel-item">-->
            <!--<img class="d-block w-100" src="@/assets/img/Wagon.jpg"
              alt="Third slide">-->
            <!--</div>-->
          </div>

          <a
            class="carousel-control-prev"
            href="#carouselExampleControls"
            role="button"
            data-slide="prev"
            @click.prevent="incIndex()"
            id="carousel-prev"
												data-test="mastHeadCarouselPrevLink"
          >
            <span
              class="carousel-control-prev-icon"
              aria-hidden="true"
              id="carousel-prev-icon"
														data-test="mastHeadCarouselPrevSpan1"
            >

            </span>
            <span
              class="sr-only"
              id="carousel-prev-span"
														data-test="mastHeadCarouselPrevSpan2"
            >
              Previous
            </span>
          </a>
          <a
            class="carousel-control-next"
            href="#carouselExampleControls"
            role="button"
            data-slide="next"
            @click.prevent="decIndex()"
            id="carousel-next"
												data-test="mastHeadCarouselNextLink"
          >
            <span
              class="carousel-control-next-icon"
              aria-hidden="true"
              id="carousel-next-icon"
														data-test="mastHeadCarouselNextSpan1"
            >
            </span>
            <span
              class="sr-only"
              id="carousel-next-span"
														data-test="mastHeadCarouselNextSpan2"
            >
              Next
            </span>
          </a>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
/* eslint-disable max-len */
import { mapActions, mapGetters } from 'vuex'

export default {
	data () {
		return {
			promotionLength: 0,
			activeIndex: 0
		}
	},
	watch: {
		promotions () {
			this.promotionLength = this.promotions ? this.promotions.length : 0
		}
	},
	mounted () {
		this.promotionLength = this.promotions ? this.promotions.length : 0
		setInterval(() => {
			this.incIndex()
		}, 5000)
	},
	computed: {
		...mapGetters('promotions', ['getAllPromotions']),
		...mapGetters('category', ['getCategoryData']),
		promotions () {
			return this.getAllPromotions.filter(promotion =>
				promotion.promotion_type.replace(/\s+/g, '').toLowerCase() !== 'dealoftheday')
		}
	},
	methods: {
		...mapActions('productselected', ['setSelectedProductData', 'clearSelectedProductData']),
		...mapActions('category', ['setActiveCategories']),
		...mapActions('filters', ['updatePriceRange', 'updateKeyWord', 'updateFilterApplied']),
		promotionFunction (promotion) {
			this.$router.push({
				path: '/promotional_product-list',
				query: {
					promotionId: promotion.promotion_id,
					display_text: promotion.promotion_id
				}
			})
		},
		incIndex () {
			if (this.activeIndex < (this.promotionLength - 1)) {
				this.activeIndex += 1
			} else {
				this.activeIndex = 0
			}
		},
		decIndex () {
			if (this.activeIndex === 0) {
				this.activeIndex = (this.promotionLength - 1)
			} else {
				this.activeIndex -= 1
			}
		},
		redirectionToWpi () {
			window.location.href = 'https://www.womenpowerinternational.com/'
		}
	}
}
</script>
